module.exports = __webpack_public_path__ + "static/china-wall-poster-e4fc47ab9df3effb547b90c339164ac9.jpg";